export const ORGANIZATION_PROJECT_PICKER_KEY = 'organization-project-picker';
export const ORGANIZATION_PROJECT_PAGE_SIZE = 50;
export const ORGANIZATION_PROJECT_STALE_TIME = 5 * 60_000;
